<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="Normal ParaOverride-1"><span class="CharOverride-1">Subterranean Fire</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">A History of Working-Class <br/>Radicalism in the United States</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Updated Edition</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Sharon Smith</span></p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer003">
<img alt="" class="_idGenObjectAttribute-1" src="Images/HayLogo.Hor.2Line.Black.png"/>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer002">
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Chicago, Illinois</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?b041ca30